import { render, staticRenderFns } from "./AlBadge.vue?vue&type=template&id=653b672f&"
import script from "./AlBadge.vue?vue&type=script&lang=js&"
export * from "./AlBadge.vue?vue&type=script&lang=js&"
import style0 from "./AlBadge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports